/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskServiceModalEditRoute } from '@jira/router-routes__servicedesk-services-routes/src/servicedeskServiceModalEditRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceUpdateModalWithoutProjectContext, {
	LazyServiceUpdateModalWithProjectContext,
} from './ui/service-update-modal-without-project-context/index.tsx';

export const servicedeskServiceModalEditRouteEntry: Route = createEntry(
	servicedeskServiceModalEditRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceUpdateModalWithoutProjectContext,
		layout: serviceProjectLayout,
		resources: [...getServiceDeskNavigationResources(), ...getServicedeskPageContextResources()],
		forPaint: [LazyAtlassianNavigation, LazyServiceUpdateModalWithProjectContext],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
